module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container login-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10 offset-1 col-md-6 offset-md-3 section"
  }, [_c('h1', [_vm._v("Reset Password")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "method": "POST",
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.reset($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "placeholder": "Enter Username"
    },
    domProps: {
      "value": _vm._s(_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10 offset-1 col-md-6 offset-md-3 section-blank"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Back to Login")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Submit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30568ffe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/PasswordReset.vue
// module id = 376
// module chunks = 0